var exports = {
  "r3": "dialog-dUlFN",
  "wx": "header-dUlFN",
  "aY": "headerButton-dUlFN",
  "VN": "close-dUlFN",
  "pD": "maximize-dUlFN",
  "nr": "headerIcon-dUlFN",
  "TK": "headerText-dUlFN",
  "Qs": "content-dUlFN",
  "Y5": "fullscreen-dUlFN",
  "o1": "actions-dUlFN",
};

module.exports = exports;
